function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import classnames from 'classnames';
import TextBoxWithIcon from '../../molecules/TextBoxWithIcon';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';

var _ref = React.createElement(SvgIcon, {
  className: "menu__search--icon",
  iconName: "ico_search-menu",
  color: "none"
});

var _ref2 = React.createElement("div", {
  className: "menu__search--label"
}, "S\xF8k");

var MenuSearch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuSearch, _React$Component);

  function MenuSearch(props) {
    var _this;

    _classCallCheck(this, MenuSearch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuSearch).call(this, props));
    _this.state = {
      searchFocus: false,
      searchQuery: ''
    };
    _this.onSearchQueryChange = _this.onSearchQueryChange.bind(_assertThisInitialized(_this));
    _this.onContainerClick = _this.onContainerClick.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onClickaway = _this.onClickaway.bind(_assertThisInitialized(_this));
    _this.onGlobalKeyDown = _this.onGlobalKeyDown.bind(_assertThisInitialized(_this));
    _this.onContainerRef = _this.onContainerRef.bind(_assertThisInitialized(_this));
    _this.onCloseButtonClick = _this.onCloseButtonClick.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MenuSearch, [{
    key: "isDescendant",
    value: function isDescendant(parent, child) {
      while (child) {
        if (child === parent) {
          return true;
        }

        child = child.parentNode;
      }

      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onClickaway);
      document.addEventListener('keydown', this.onGlobalKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClickaway);
      document.removeEventListener('keydown', this.onGlobalKeyDown);
    }
  }, {
    key: "onClickaway",
    value: function onClickaway(event) {
      if (this.container && !this.isDescendant(this.container, event.target)) {
        this.setState({
          searchFocus: false
        });
      }
    }
  }, {
    key: "onGlobalKeyDown",
    value: function onGlobalKeyDown(e) {
      var key = e.which || e.keyCode;

      if (key === 27 && this.state.searchFocus) {
        // escape key
        this.setState({
          searchFocus: false
        });
      }
    }
  }, {
    key: "onSearchQueryChange",
    value: function onSearchQueryChange(event) {
      this.setState({
        searchQuery: event.target.value
      });
    }
  }, {
    key: "onContainerRef",
    value: function onContainerRef(container) {
      this.container = container;
    }
  }, {
    key: "onContainerClick",
    value: function onContainerClick(e) {
      var _this2 = this;

      e.stopPropagation();
      setTimeout(function () {
        _this2.setState({
          searchFocus: true
        });
      }, 1);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var key = e.which || e.keyCode;

      if (key === 13) {
        // enter
        this.onContainerClick(e);
      }
    }
  }, {
    key: "onCloseButtonClick",
    value: function onCloseButtonClick(e) {
      e.stopPropagation();
      this.setState({
        searchFocus: false,
        searchQuery: ''
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();
      this.props.onSubmit(e, this.state.searchQuery);
      this.setState({
        searchFocus: false,
        searchQuery: ''
      });
    }
  }, {
    key: "renderSearchField",
    value: function renderSearchField() {
      var _this3 = this;

      return React.createElement("form", {
        onSubmit: this.onSubmit,
        className: "menu__search--open-form"
      }, React.createElement(TextBoxWithIcon, {
        type: "search",
        autoFocus: true,
        iconName: "ico_search",
        iconLabel: "Search",
        iconIsButton: true,
        small: true,
        onChange: function onChange(e) {
          return _this3.onSearchQueryChange(e);
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var searchFocus = this.state.searchFocus;
      return React.createElement("div", {
        tabIndex: "0",
        ref: this.onContainerRef,
        className: classnames('menu__search', {
          'menu__search--focused': searchFocus
        }),
        onClick: this.onContainerClick,
        onKeyDown: this.onKeyDown
      }, _ref, _ref2, searchFocus && React.createElement("div", {
        className: "menu__search--open"
      }, this.renderSearchField(), React.createElement("span", {
        tabIndex: "0",
        className: "menu__search--open-abort-button",
        onKeyDown: function onKeyDown(e) {
          return _this4.onCloseButtonClick(e);
        },
        onClick: function onClick(e) {
          return _this4.onCloseButtonClick(e);
        }
      }, "Avbryt")));
    }
  }]);

  return MenuSearch;
}(React.Component);

export { MenuSearch as default };